import { render } from "./replay-nav-icon.vue.js?vue&type=template&id=899ad3af!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./replay-nav-icon.vue?vue&type=template&id=899ad3af"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__